import CybsCard from '@cybs-ui/components/lib/card';
import $ from 'jquery';
import React from 'react';
import { initiateSampleCodeEvent } from '../../../../../../src/commons/sample-code';
import { replaceSpace, setWindowLocationHash } from '../../../../../../src/libs/common-library';
import { getDevCenterDataStore, putDataInDevCenterDataStore } from '../../../../../app/store';
import { createClass, getLanguageDetails, hideDivBasedOnId, isDefaultSite, showDivBasedOnId } from '../../../../../commons/ui-commons';
import getConfigurationJsonDataAndStoreInDataStore from '../../../../../lhs/actions/configuration-actions';
import { getLHSBasedOnHostName, getLHSJsonData, initiateDeepLink } from '../../../../../lhs/actions/navigation-actions';
import { getSecondLevelKeyFlag } from '../../../../../lhs/reducers/lhs-reducer';
import { getExampleParentName, getExampleSummary, getFirstLevelKey, getSecondLevelKey, getSelectedSampleCode, getThirdLevelKey } from '../../../reducers/examples-reducer';
import '../css/live-console.css';
import LiveConsoleTabIndex from '../js/live-console-tab-index';
import RequestBuilderTabsInLiveConsole from '../js/request-builder-tabs';
import { themeBuilder } from "@cybs-plugins/theme";
import { ThemeProvider } from "emotion-theming";
import { getPrimaryColor, getPrimarySwatch } from '../../../../../themeprovider/actions/themes-provider';
import { getIsWidget } from '../../../../../lhs/reducers/configuration-reducer';
import { connect } from 'react-redux';
import CybsAlert from '@cybs-ui/components/lib/alert';

import CybsActionBar from '@cybs-ui/components/lib/action-bar';
import CybsFormFooter from '@cybs-ui/components/lib/form-footer';
import {getRequiredFieldsFlag} from "../../../reducers/rhs-schema-reducer";


require('codemirror/lib/codemirror.css');
require('codemirror/theme/material.css');
require('codemirror/theme/neat.css');
require('codemirror/mode/xml/xml.js');
require('codemirror/mode/javascript/javascript.js');

var isDeeplinkProcessed = false;

// var selectedLanguage = [languages[0]]
function handleSampleCodeSelection(event, selected) {
    var secondLevelKey = getSecondLevelKeyFlag() ? undefined : getSecondLevelKey();
    var sampleCodeName = (getExampleSummary() != undefined) ? getExampleSummary() : getThirdLevelKey();
    initiateSampleCodeEvent(replaceSpace(getThirdLevelKey()), getFirstLevelKey(), "extension" + selected[0]['value'], secondLevelKey, sampleCodeName);
    if(getIsWidget()){
        hideDivBasedOnId("liveConsoleHeading");
    }
    hideDivBasedOnId('live-console-tabs');
    hideDivBasedOnId('config-data');
    showDivBasedOnId('sample-code');
    disableCopyMessage('copySuccessful');
    disableCopyMessage('copySuccessfulSampleCode');
    disableCopyMessage('copySuccessfulSampleCode');
    document.getElementById('footer').className = "sample-code-footer"
    var urlHash;
    if (sampleCodeName != undefined) {
        if (getExampleParentName() != undefined && sampleCodeName != undefined) {
            urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + "samplerequests-dropdown_" + replaceSpace(getExampleParentName().toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + replaceSpace(sampleCodeName.toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + replaceSpace(selected[0]['label']).toLowerCase();
        }
        else {
            urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + "samplerequests-dropdown_" + replaceSpace(sampleCodeName.toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + replaceSpace(selected[0]['label']).toLowerCase();
        }
    }
    else if(!getIsWidget()){
        urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(selected[0]['label']).toLowerCase();
    }
    if(urlHash != undefined)
    {
        setWindowLocationHash(urlHash.replace("-_","_"));
        putDataInDevCenterDataStore({type:'UPDATE_SELECTED_SAMPLE_CODE_VALUE', selectedSampleCode: selected[0]});
    }

}

function handleLiveConsoleReturn() {
    showDivBasedOnId('live-console-tabs');
    showDivBasedOnId('config-data');
    hideDivBasedOnId('sample-code');
    if(getIsWidget()){
        showDivBasedOnId("liveConsoleHeading");
    }
    document.getElementById('footer').className = "live-console-footer"
    $('button[data-test^="heading-level-tabs-live-console-0"]').trigger('click');
    var element = document.getElementById('button-live-console');
    if (getSelectedSampleCode() != 'Live Console' && element) {
        element.click();
    }

    putDataInDevCenterDataStore({
        type: 'UPDATE_SELECTED_SAMPLE_CODE_VALUE', selectedSampleCode: {
            'label': 'Live Console',
            'value': 'Live Console'
        }
    });
    putDataInDevCenterDataStore({ type: 'UPDATE_SAMPLE_CODE_VALUE', sampleCodeValue: "" });
    putDataInDevCenterDataStore({ type: 'UPDATE_SAMPLE_CODE_ERROR', sampleCodeError: undefined });

}

function headerLevelHandleSelection(e, index) {
    setHeaderLevelSelectedTab(index);
    var tabName = "";
    if(e.target.innerText.indexOf("Body") >-1)
    {
        tabName = "liveconsole-tab-request-body";
        var editor = document.querySelector('.CodeMirror').CodeMirror;
        setTimeout(function() {
            editor.refresh();
        },10)
    }
    else if (e.target.innerText.indexOf("Headers") > -1) {
        tabName = "liveconsole-tab-request-headers";
    }
    else if (e.target.innerText.indexOf("Query") > -1) {
        tabName = "liveconsole-tab-request-queryparams";
    }
    else if (e.target.innerText.indexOf("Descriptions") > -1) {
        tabName = "liveconsole-tab-request-descriptions";
    }

    var urlHash = "";
    /*    if(tabName = "liveconsole-tab-request-descriptions")
        {
            urlHash = replaceSpace(getFirstLevelKey()) +"_" + replaceSpace(getSecondLevelKey()) +"_"+ replaceSpace(getThirdLevelKey())+"_" + tabName;
        }*/
    if (getExampleSummary() != undefined) {
        if (getExampleParentName() != undefined) {
            urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + "samplerequests-dropdown_" + replaceSpace(getExampleParentName().toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + replaceSpace(getExampleSummary().toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + tabName;
        }
        else {
            urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + "samplerequests-dropdown_" + replaceSpace(getExampleSummary().toLowerCase().replace(/[\W_]+/g, " ").replace("(", "-").replace(")", "-")) + "_" + tabName;
        }
    }
    else if(!getIsWidget()){
        urlHash = replaceSpace(getFirstLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getSecondLevelKey()).replaceAll("_", "-") + "_" + replaceSpace(getThirdLevelKey()).replaceAll("_", "-") + "_" + tabName;
    }
    setWindowLocationHash(urlHash.replace("-_","_"));
};

function bodyLevelHandleSelection(e, index) {
    setBodyLevelSelectedTab(index);
};

function setBodyLevelSelectedTab(index) {
    putDataInDevCenterDataStore({ type: 'UPDATE_REQUEST_BUILDER_TAB_INDEX', requestBuilderTabIndex: index });
};

function setHeaderLevelSelectedTab(index) {
    putDataInDevCenterDataStore({ type: 'UPDATE_LIVE_CONSOLE_TAB_INDEX', liveConsoleTabIndex: index });
};

class LiveConsole extends React.Component {

    // LiveConsole(){
    // }

    constructor(props) {
        super(props);
        putDataInDevCenterDataStore({ type: 'UPDATE_REQUEST_BUILDER_TAB_INDEX', requestBuilderTabIndex: 0 });
        putDataInDevCenterDataStore({ type: 'UPDATE_LIVE_CONSOLE_TAB_INDEX', liveConsoleTabIndex: 0 });
    }

    componentDidMount() {
        // Override the text on component mount
        $(".alert-required-fields").hide();
    }

    // sampleRequestDropDownContents = <div></div>;

    render() {
        var theme = themeBuilder(getPrimarySwatch());
        if (this.props != undefined) {
            if (theme != undefined && getPrimarySwatch() != undefined) {
                return (
                    <ThemeProvider theme={theme}>
                        <div style={{ width: '100%' }}>
                            <div style={{ marginRight: '10px', marginLeft: '10px', display: 'flex' }}>
                                <div style ={{width:"100%"}}>
                               { <div class="alert-required-fields">
                                    <CybsAlert 
                                        dataTest="neutral"
                                        isInline
                                        i18n={{
                                            message: ""
                                        }}
                                        isVisible="hide"
                                        />
                                    </div>
                                }
                
                                <CybsCard
                                    dataTest="live-console-container-request-builder"
                                    header={
                                        <div>
                                            <RequestBuilderTabsInLiveConsole />
                                        </div>
                                    }
                                    style={{ marginRight: "5px", maxWidth: '100%' }}
                                >
                                </CybsCard>
                                </div>
                                <LiveConsoleTabIndex />
                            </div>

                        </div>
                    </ThemeProvider>
                )
            }
            else {
                return (
                    <div>
                    </div>
                )
            }
        }

        else {
            return (
                <div>
                </div>
            )
        }


    }
}

function enableCopyMessage(id) {
    var element = document.getElementById(id);
    if (element != null) {
        element.style.display = "block";
    }
}


function disableCopyMessage(id) {
    var element = document.getElementById(id);
    if (element != null) {
        element.style.display = "none";
    }
}

function mapStateToProps(state){
    if(getRequiredFieldsFlag() && $(".alert-required-fields").css('display') === 'none') {
        $(".alert-required-fields").show();
        var field_alert_text_ele = document.getElementById('field-alert-text');
        if (field_alert_text_ele) {
            var field_alert_text = field_alert_text_ele.innerHTML;
            $(".alert-required-fields .vds-alert .vds-alert-label").html(field_alert_text);
        } else {
            $(".alert-required-fields .vds-alert .vds-alert-label").html("Required fields are denoted with an " +
                "<span class='mandatory-asterisk'>*</span>. Objects with <span class='mandatory-caret'>^</span>" +
                " are optional, however if provided, they have required fields under them - marked with an" +
                " <span class='mandatory-asterisk'>*</span>");
        }
        $(".alert-required-fields .vds-alert.vds-alert--information").addClass('border_color_theme_primary_bottom');
    }else if(!getRequiredFieldsFlag() && $(".alert-required-fields").css('display') === 'block'){
        $(".alert-required-fields").hide();
    }
    if(state.configurationReducer.isWidget && !isDeeplinkProcessed){
        var fileName = window.location.hostname;
        
        if (fileName != null) {
            fileName = fileName.replaceAll(".", "-");
        }
        
        var exampleName = document.getElementById('apiReferenceWidget').getAttribute('example-name');
        const sampleRequestMapping = require('../../../../../dist/json/sample_request_api_mapping.json');

        
        for(var example in sampleRequestMapping){
            if(example.toLowerCase().replace(/[^a-zA-Z]/g, '') == exampleName.toLowerCase().replace(/[^a-zA-Z]/g, '')){
                var third_level = replaceSpace(sampleRequestMapping[example]['thirdLevel']);
                var widgetExampleKey = sampleRequestMapping[example]['exampleKey'];
                putDataInDevCenterDataStore({type:'UPDATE_WIDGET_EXAMPLE_KEY', widgetExampleKey: widgetExampleKey});

                const configData = require('../../../../../dist/json/credentials/' + fileName);
                getConfigurationJsonDataAndStoreInDataStore(configData, window.location.hostname);
                const customData = require('../../../../../dist/json/lhs/'+getLHSBasedOnHostName());
                var lhsContents = getLHSJsonData([], customData,{},true);
                initiateDeepLink(lhsContents,third_level);
                isDeeplinkProcessed = true;
                return {
                }
            }
        }

        // if the sample request (exampleName) provided does not exist in the API specification examples
        console.error("The Sample Request " + exampleName + " is invalid."); 
    }

    return {
    }
}

LiveConsole.displayName = 'CybsCardExample';
export default connect(mapStateToProps)(LiveConsole);

export { enableCopyMessage, disableCopyMessage, handleSampleCodeSelection, handleLiveConsoleReturn, headerLevelHandleSelection, bodyLevelHandleSelection, setBodyLevelSelectedTab, setHeaderLevelSelectedTab };

